import "./LegalHero.css";

function LegalHero({ title, subtitle }) {
  return (
    <div className="LegalHero section" id="LegalHero">
      <div className="container">
        <div className="LegalHero-box">
          <h1>{title}</h1>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
      </div>
    </div>
  );
}

export default LegalHero;
